module.exports = {
	"id": "abt610",
	"enabled": false,
	"type": "standard",
	"split": 2,
	"dateRange": [
		{
			"start": "2016-11-01T09:00:00-05:00",
			"end": "2016-11-05T23:59:59-05:00"
		}
	],
	"cookieExpiration": "2016-11-05T23:59:59-05:00",
	"evar": {
		"number": 68,
		"qa": 68,
		"name": "tab_accordions",
		"skip": true
	},
	"pageCriteria": {
		"pageType": [
			"browse,pdp"
		]
	},
	"deviceSize": [
		"s",
		"m",
		"l"
	]
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/abt-tests/abt610/config.json
 ** module id = 38
 ** module chunks = 2
 **/